(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recesso-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    const section     = document.querySelector('.recesso-section[data-make-webhook]');
    const form        = document.getElementById('recesso-form');
    const btn         = document.getElementById('recesso-btn');
    const strings     = document.getElementById('recesso-js-strings');
    const subjectFld  = document.getElementById('recesso-subject');

    if (!form || !section) return;

    const WEBHOOK_URL = section.dataset.makeWebhook;
    const LANG        = section.dataset.lang;
    const NOME_SITO   = section.dataset.nomeSito;
    const SENDING     = strings ? strings.dataset.sending  : 'Sending…';
    const ERR_GENERIC = strings ? strings.dataset.error    : 'Error. Try again.';
    const BTN_LABEL   = strings ? strings.dataset.btnLabel : btn.textContent.trim();

    function pad(n) { return String(n).padStart(2, '0'); }

    function getTimestamp() {
      const now = new Date();
      return pad(now.getDate()) + '/' + pad(now.getMonth()+1) + '/' + now.getFullYear()
        + ' ' + pad(now.getHours()) + ':' + pad(now.getMinutes());
    }

    function setLoading(on) {
      btn.disabled = on;
      if (on) {
        btn.innerHTML = '<span class="recesso-spinner"></span><span>' + SENDING + '</span>';
      } else {
        btn.innerHTML = '<span class="recesso-btn-submit__icon">📩</span><span>' + BTN_LABEL + '</span>';
      }
    }

    function showError(msg) {
      let el = form.querySelector('.recesso-net-error');
      if (!el) {
        el = document.createElement('div');
        el.className = 'recesso-error recesso-net-error';
        el.setAttribute('role', 'alert');
        form.prepend(el);
      }
      el.textContent = '⚠️ ' + msg;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function clearError() {
      const el = form.querySelector('.recesso-net-error');
      if (el) el.remove();
    }

    form.addEventListener('submit', async function (e) {

      const privacy = form.querySelector('#recesso-privacy');
      if (privacy && !privacy.checked) {
        e.preventDefault();
        privacy.style.outline = '2px solid #c0392b';
        privacy.closest('.recesso-privacy').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const ts = getTimestamp();
      if (subjectFld) {
        subjectFld.value = subjectFld.value.replace(/\s*[-–]\s*[\d/: ]+$/, '') + ' - ' + ts;
      }

      const name        = (form.querySelector('[name="contact[name]"]')     || {}).value || '';
      const email       = (form.querySelector('[name="contact[email]"]')    || {}).value || '';
      const ordine      = (form.querySelector('[id="recesso-ordine"]')      || {}).value || '';
      const dataOrdine  = (form.querySelector('[id="recesso-data-ordine"]') || {}).value || '';
      const motivazione = (form.querySelector('[id="recesso-motivazione"]') || {}).value || '';
      const prodotti    = (form.querySelector('[name="contact[body]"]')     || {}).value || '';

      const payload = {
        lingua:      LANG,
        nome_sito:   NOME_SITO,
        timestamp:   ts,
        nome:        name,
        email:       email,
        ordine:      ordine,
        data_ordine: dataOrdine,
        motivazione: motivazione,
        prodotti:    prodotti
      };

      if (!WEBHOOK_URL || WEBHOOK_URL.trim() === '') {
        return;
      }

      e.preventDefault();
      clearError();
      setLoading(true);

      try {
        await fetch(WEBHOOK_URL, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify(payload),
          mode:    'no-cors'
        });
      } catch (err) {
        console.warn('[Recesso] webhook error:', err);
        showError(ERR_GENERIC);
        setLoading(false);
        return;
      }

      setLoading(false);
      form.submit();

    });

  });
})();

  } catch(e) { console.error(e); }
})();
})();
